import { g as _defineProperty, _ as _objectSpread2 } from '../../_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var _init_state_quote;
var init_state_quote = (_init_state_quote = {
  get_covers: false,
  quotationNo: '',
  quotationStatus: '',
  quoteCreationDate: '',
  quoteUpdationDate: '',
  isSaveQuoteEnabled: false,
  isPremiumCalculated: false,
  isQuoteSubmitting: false,
  isQuoteSaving: false,
  proposalNumber: '',
  currentTab: 0,
  captureMode: 'create',
  pendingMessage: '',
  loadingmedical: '',
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: ''
  },
  isApprover: '',
  uw_role_name: '',
  businessOfInsured: '',
  locationDetails: [],
  industryCategory: '',
  industryCategoryValue: '',
  industryCategory_id: '',
  sub_industryCategory_id: '',
  description: '',
  endorsementNo: '',
  aagrevalue: '',
  industrySubCategory: '',
  tacCode: '',
  industrySubCategoryValue: '',
  policyType: '',
  policyTypeValue: '',
  locationType: '',
  locationTypeValue: '',
  allIndiaBasisDescription: '',
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  landmark: '',
  pincode: '',
  stateLocation: '',
  policyStartDate: '',
  policyEndDate: '',
  prevClaim: '',
  policyPeriodInMonths: '12',
  policyTenure: '1',
  policyTenureValue: '1 year',
  loading: '',
  discount: '',
  loadRate: '',
  employeeDetailsBase64String: '',
  employeeDetailsExcelFileName: '',
  totalNoOfEmployeesInFile: 0,
  addOnCovers: {},
  rawRiskData: [],
  employeedocumentsDetails: [],
  coverDetails: [],
  documentDetails: [],
  defaultClauses: [],
  userDefinedClauses: [],
  defaultConditions: [],
  userDefinedConditions: [],
  defaultExclusions: [],
  userDefinedExclusions: [],
  defaultWarranties: [],
  userDefinedWarranties: [],
  subCat: [],
  underWriterComments: '',
  loadingCalcPremium: '',
  discountCalcPremium: '',
  isPremiumCalculating: false
}, _defineProperty(_init_state_quote, "isPremiumCalculated", false), _defineProperty(_init_state_quote, "calculatedPremium", {
  netPremium: '',
  GST: '',
  totalPremium: '',
  stampDuty: ''
}), _defineProperty(_init_state_quote, "customer", {}), _defineProperty(_init_state_quote, "customerMeta", {}), _defineProperty(_init_state_quote, "clauses", {}), _defineProperty(_init_state_quote, "warranties", {}), _defineProperty(_init_state_quote, "conditions", {}), _defineProperty(_init_state_quote, "exclusions", {}), _defineProperty(_init_state_quote, "tabDetails", {
  additionalTabDetails: {
    warranties: {
      defaultWarranties: [],
      userDefinedWarranties: []
    },
    exclusions: {
      defaultExclusions: [],
      userDefinedExclusions: []
    },
    clauses: {
      defaultClauses: [],
      userDefinedClauses: []
    },
    conditions: {
      defaultConditions: [],
      userDefinedConditions: []
    },
    underwriterComment: ''
  }
}), _init_state_quote);
var is_India_Basis = {
  isIndiaBasis: false
};
var workCompQuoteVar = makeVar(init_state_quote);
var isAllIndiaVar = makeVar(is_India_Basis); // export const initWorkmenCompensationQuoteState = () =>
//   workCompQuoteVar(init_state_quote);

var initWorkmenCompensationQuoteState = function initWorkmenCompensationQuoteState(isCopyFromOutside) {
  var _workCompQuoteVar;

  if (isCopyFromOutside && (_workCompQuoteVar = workCompQuoteVar()) !== null && _workCompQuoteVar !== void 0 && _workCompQuoteVar.isCopyFromOutside) {
    workCompQuoteVar(_objectSpread2(_objectSpread2({}, workCompQuoteVar()), {}, {
      isCopyFromOutside: false
    }));
    return true;
  }

  workCompQuoteVar(init_state_quote);
  return false;
};
var updateWorkmenCompensationQuote = function updateWorkmenCompensationQuote(data) {
  workCompQuoteVar(_objectSpread2(_objectSpread2({}, workCompQuoteVar()), data));
};
var updateCustomerInformation = function updateCustomerInformation(customerInformation) {
  return workCompQuoteVar(_objectSpread2(_objectSpread2({}, workCompQuoteVar()), {}, {
    customer: customerInformation !== null && customerInformation !== void 0 && customerInformation.customer ? customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.customer : {},
    customerMeta: customerInformation !== null && customerInformation !== void 0 && customerInformation.customerMeta ? customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.customerMeta : {}
  }));
};
var updateQuotationDetails = function updateQuotationDetails(quotationNo, quotationStatus, quoteCreationDate, addOnCovers, rawRiskData) {
  if (addOnCovers && rawRiskData) {
    workCompQuoteVar(_objectSpread2(_objectSpread2({}, workCompQuoteVar()), {}, {
      quotationNo: quotationNo,
      quotationStatus: quotationStatus,
      quoteCreationDate: quoteCreationDate,
      addOnCovers: addOnCovers,
      rawRiskData: rawRiskData
    }));
  } else {
    workCompQuoteVar(_objectSpread2(_objectSpread2({}, workCompQuoteVar()), {}, {
      quotationNo: quotationNo,
      quotationStatus: quotationStatus,
      quoteCreationDate: quoteCreationDate
    }));
  }
};
var updateIsAllIndiaBasisData = function updateIsAllIndiaBasisData(data) {
  isAllIndiaVar({
    isIndiaBasis: data
  });
};

export { initWorkmenCompensationQuoteState, init_state_quote, isAllIndiaVar, updateCustomerInformation, updateIsAllIndiaBasisData, updateQuotationDetails, updateWorkmenCompensationQuote, workCompQuoteVar };
